// Coalesces bursts of "something changed" signals into refetches at most
// once per minGapMs — a busy room emits many socket events per second, and
// the dashboard must never refetch per event (specs/workshop-dashboard.md).

export function createRefetchCoalescer(run, minGapMs) {
  let lastRunAt = 0;
  let pendingTimer = null;
  let disposed = false;

  const fire = () => {
    pendingTimer = null;
    lastRunAt = Date.now();
    run();
  };

  return {
    /** Ask for a refetch; runs now if the gap has passed, else once at gap end. */
    request() {
      if (disposed || pendingTimer !== null) return;
      const wait = Math.max(0, minGapMs - (Date.now() - lastRunAt));
      if (wait === 0) {
        fire();
      } else {
        pendingTimer = setTimeout(fire, wait);
      }
    },
    dispose() {
      disposed = true;
      if (pendingTimer !== null) clearTimeout(pendingTimer);
      pendingTimer = null;
    },
  };
}
